import { Card } from "primereact/card"
import gpraStyles from "../../styles/Participant-GPRA.module.css"
import { formatToLocalDate } from "./utils/utils"
import { useQuery, gql } from "@apollo/client"
import { LoaderMedium } from "../../components/Loaders"
import { useState } from "react"
import { useEffect } from "react"
import DeleteGpraRecord from "./RecordCRUD/deleteRecord"
import CreateGpraRecord from "./RecordCRUD/createRecord"
import { Tooltip } from "primereact/tooltip"

const StatusCard = ({
  gpra_record,
  ableToDelete,
  ableToCreate,
  setReloadStatus,
  staff_id,
  membership_uuid,
  inactiveParticipant,
  organization_alias,
  organization_id,
  organization_name,
  participant_id,
  participant_name,
  participant_uuid,
  program_list,
  startedIntake,
  startedFollowUp,
  startedDischarge,
  completedIntake,
  completedFollowUp,
  completedDischarge,
  dischargeStartDate,
  recordStatus,
  blocked,
}) => {
  const [program, setProgram] = useState()
  const [staffData, setStaffData] = useState()
  const [programEnabled, setProgramEnabled] = useState()

  const cardHeader = () => {
    return (
      <div className={gpraStyles.interviewCardHeader}>
        <h3>
          <b>Record</b>
        </h3>
        <h3>
          <b>
            Status:{" "}
            {gpra_record?.gpraRecordStatus === "Active"
              ? "In Progress"
              : gpra_record?.gpraRecordStatus !== "Complete"
              ? "Incomplete"
              : gpra_record?.gpraRecordStatus}
          </b>
        </h3>
      </div>
    )
  }
  const GET_USER = gql`
    query user($staff_id: ID!, $organization_id: ID!) {
      user(staff_id: $staff_id, organization_id: $organization_id) {
        staff_name_first
        staff_name_last
      }
    }
  `
  const staffQuery = useQuery(GET_USER, {
    variables: {
      staff_id: gpra_record?.createdBy,
      organization_id: gpra_record?.organizationUuid,
    },
    onCompleted: (result) => {
      setStaffData(result.user)
    },
    onError: (error) => {
      console.log(error)
    },
  })
  const GET_PROGRAMS = gql`
    query Programs($staff_id: ID!, $organization_id: ID!) {
      programs(staff_id: $staff_id, organization_id: $organization_id) {
        program_identity_id
        program_id_name
        program_id_status
        program_id_create_date
        program_id_change_date
        organization_id
        organization_name
        program_id_gpra
      }
    }
  `
  const progQuery = useQuery(GET_PROGRAMS, {
    variables: {
      staff_id: gpra_record?.createdBy,
      organization_id: gpra_record?.organizationUuid,
    },
    onCompleted: ({ programs }) => {
      setProgram(
        programs.filter(
          (p) => p?.program_identity_id === gpra_record?.gpraProgramId
        )[0]
      )
    },
    skip: programEnabled || !gpra_record?.createdBy,
    onError: (error) => {
      console.log(error)
    },
  })
  useEffect(() => {
    if (program) {
      setProgramEnabled(program.program_id_gpra)
    }
  }, [program])

  const createdByFormatted = () => {
    if (staffData) {
      return `${staffData?.staff_name_first} ${staffData?.staff_name_last}`
    }
    return "Unknown"
  }
  return (
    <>
      {staffQuery.loading || progQuery.loading ? (
        <LoaderMedium />
      ) : (
        <Card header={cardHeader} className={gpraStyles.card}>
          <div className={gpraStyles.interviewCardContainer}>
            <div className={gpraStyles.interviewCardDetailsContainer}>
              <p className={gpraStyles.p}>
                <b>Assigned Program: </b>
                {program ? program?.program_id_name : "Not found"}
                {!programEnabled && (
                  <>
                    <Tooltip
                      target=".custom-target-icon-delete"
                      position="left"
                      className="custom-tooltip"
                    >
                      <div>
                        <p
                          style={{
                            marginLeft: "1rem",
                            display: "inline-block",
                          }}
                        >
                          <i>
                            Notice: This Program is no longer GPRA-enabled. This
                            does not effect any existing GPRA records but will
                            prevent it from being selected for new GRPA records.
                          </i>
                        </p>
                      </div>
                    </Tooltip>
                    <i
                      className={`${"custom-target-icon-delete pi pi-envelope p-text-secondary pi-info-circle"} ${
                        gpraStyles.interviewCardTooltipIcon
                      }`}
                    ></i>
                  </>
                )}
              </p>
              <p
                className={`${gpraStyles.p} ${gpraStyles.interviewCardDetails}`}
              >
                <b>Creation date: </b>
                {formatToLocalDate(gpra_record?.dateCreated)}
              </p>
              <p
                className={`${gpraStyles.p} ${gpraStyles.interviewCardDetails}`}
              >
                <b>Created by: </b>
                {createdByFormatted()}
              </p>
            </div>
            <div className={gpraStyles.interviewCardButtonsContainer}>
              <DeleteGpraRecord
                setReloadStatus={setReloadStatus}
                gpra_record_id={gpra_record.gpraRecordId}
                ableToDelete={ableToDelete}
                startedIntake={startedIntake}
                startedFollowUp={startedFollowUp}
                startedDischarge={startedDischarge}
                completedIntake={completedIntake}
                completedFollowUp={completedFollowUp}
                completedDischarge={completedDischarge}
                blocked={blocked}
              />
              <CreateGpraRecord
                inactiveParticipant={inactiveParticipant}
                membership_uuid={membership_uuid}
                organization_alias={organization_alias}
                organization_id={organization_id}
                organization_name={organization_name}
                participant_id={participant_id}
                participant_name={participant_name}
                participant_uuid={participant_uuid}
                program_list={program_list}
                setReloadStatus={setReloadStatus}
                staff_id={staff_id}
                ableToCreate={ableToCreate}
                dischargeStartDate={dischargeStartDate}
                recordStatus={recordStatus}
              />
            </div>
          </div>
        </Card>
      )}
    </>
  )
}
export default StatusCard
